import React from 'react'
import classnames from 'classnames'
import { daysOfWeek, isWeekend, truncateDay } from '../../../../../week'
import Session from './session'
import { feeIsHourly } from '../helper'

const Day = ({ day, sessions = [], compact, showWarningFun }) => (
  <div
    className={classnames({
      weekDay: true,
      weekDay__isWeekend: isWeekend(day.value),
    })}>
    <h4>{compact ? truncateDay(day.label) : day.label}</h4>
    <ol>
      {sessions.map((session, i) => (
        <Session
          key={`daily_sessions_${i}`}
          session={session}
          isHourlySession={feeIsHourly(session)}
          showWarningFun={showWarningFun}
        />
      ))}
    </ol>
  </div>
)

const SessionsForWeek = ({ weeklySessions, compact, showWarningFun }) => (
  <div className="week">
    {daysOfWeek.map((day, i) => (
      <Day
        key={`day_+${i}`}
        day={day}
        sessions={weeklySessions[i + 1]}
        compact={compact}
        showWarningFun={showWarningFun}
      />
    ))}
  </div>
)

export default SessionsForWeek



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/booking-schedules/views/sessions-for-week.jsx